import { ITrailer, ITrailerData } from '../interfaces/Trailer.interface';
import { extractAndEncode } from '../utils/string';
import { axiosAuthInstance } from './Auth.service';

export const getTrailerList = async (
  limit: number,
  offset: number,
  nextLink?: string,
  country?: string,
  transporterIds?: string[],
  productIds?: string[],
  searchQuery?: string
): Promise<ITrailerData> => {
  const client = await axiosAuthInstance();
  let queryParams = '';
  
  if (country !== undefined && country.length > 0) {
    queryParams += `&country_name=${country}`;
  }

  transporterIds?.forEach((filter) => {
    queryParams += `&transporterIds[]=${filter}`;
  });

  productIds?.forEach((filter) => {
    queryParams += `&dproductIds[]=${filter}`;
  });

  if (searchQuery !== undefined && searchQuery.length > 0) {
    queryParams += `&search=${searchQuery}`;
  }

  if (nextLink !== undefined) {
    queryParams += `&nextLink=${extractAndEncode(nextLink)}`;
  }
  
  const response = await client.get(`/trailer/list?limit=${limit}&offset=${offset}${queryParams}`);

  return {
    ...response.data,
    nextLink: response.data.pagination?.nextLink,
  };
};

export const getTrailer = async (id: string): Promise<ITrailer> => {
  const client = await axiosAuthInstance();
  const response = await client.get(`/trailer/${id}`);
  return response.data;
};